import {colors, translations} from '@/helpers/transferStatus'

export default function () {
  return {
    page: 1,
    totalPages: 0,
    perPage: 15,
    searchParams: {},
    transfers: [],
    colors,
    translations,
    showTransferDetails: false,
    transferDetails: null,
    fields: [
      {
        key: 'trip',
        label: 'Pedido'
      },
      {
        key: 'createdAt',
        label: 'Data'
      },
      {
        key: 'status',
        label: 'Status'
      },
    ]
  }
}
